import SmoothScroll from 'smooth-scroll';

export default (selector) => {

  const a = {}
  const init = () => {
    a.targetSelector = selector;
    a.targets = document.querySelectorAll(a.targetSelector);
    if (!a.targets.length) {
      return;
    }

    new SmoothScroll(a.targetSelector, {
      speed: 300,
      updateURL: false
    })
  }

  init ();
}
